import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import Models from './eficienciaModel.json';
import "./tables.scss";
import "./Puestos.scss";
import { httpGet, httpPost, httpPUT, httpDelete } from "../../common/petitions";
import DataLoader from "../../components/tableData";
import { useNavigate } from 'react-router-dom';

const eficiencias = () => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const rowsData = await httpGet(`/gasolina/eficiencias/20242025`, navigate);
      const jsonData = { columns: Models.fuel, rows: rowsData };
      console.log(jsonData);
      setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
    setIsLoading(false);
  };





  document.title = "Combustibles - Eficiencias - IPG";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Combustibles" title="Eficiencias" />

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  {<DataLoader isLoading={isLoading} data={data} />}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

    </React.Fragment>
  );
};

export default eficiencias;
